import styled from 'styled-components';

export const H1 = styled.h1`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 32px;
  line-height: 40px;
  color: ${({ theme }) => theme.colors.charcoal};
  opacity: 0.9;

  @media (max-width: 992px) {
    font-size: 30px;
  }
`;

export const SelectionTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: #6c6c6c;

  opacity: 0.9;
`;

export const SelectedOption = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  /* identical to box height, or 177% */

  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.french};
`;

export const ProductPrice = styled.div`
  /* Subheading 1 / Bold */

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};

  opacity: 0.9;
`;

export const FilterTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  color: #4b4b4b;
`;

export const FilterButton = styled.div`
  cursor: pointer;
  margin: 5px;
  background: white;
  border: ${({ selected }) =>
    selected ? '2px solid #A83569' : '1px solid #dadada'};
  display: inline;
  padding: 10px;
  border-radius: 30px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;

  letter-spacing: 0.04em;

  color: #717171;
`;

export const Tooltip = styled.div`
  box-sizing: border-box;
  left: -5px;
  position: absolute;
  top: 36px;
  width: 180px;
  z-index: 99;
  background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border: 1px solid rgb(213, 213, 213);
  font: normal normal 500 normal 16px / 24px ${({ theme }) => theme.fonts.primary};

  transform: scale(0);

  padding: 10px 15px;
  transition: all 0.2s cubic-bezier(0.75, -0.02, 0.2, 0.97) 0s;
  .tooltip-arrow {
    height: 8px;
    left: 5px;
    position: absolute;
    top: -9px;
    margin: 0px 4.8px;

    &:after {
      box-sizing: border-box;
      content: '';
      left: 0px;
      position: absolute;
      right: 0px;
      top: 1px;
      width: 16px;
      border-top: 0px solid rgba(0, 0, 0, 0);
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgb(255, 255, 255);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
    &:before {
      box-sizing: border-box;
      content: '';
      display: block;
      height: 8px;
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgba(0, 0, 0, 0.25);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
  }
  .desc {
    text-align: center;
    color: rgb(104, 104, 104);
    font: normal normal 500 normal 12px / 18px ${({ theme }) => theme.fonts.primary};
    margin: 0px;
  }
`;
